/* Fonte única dos projetos exibidos no grid da Home.
   O Dashboard Imobiliário é tratado à parte (seção de destaque). */

const projetos = [
  {
    id: "assistente",
    route: "/assistente-ia",
    titulo: "Assistente Inteligente Imobiliário",
    descricao:
      "Ecossistema de atendimento e triagem automatizada com IA, integração ao CRM, Google Agenda e API oficial do WhatsApp. Em operação real.",
    capa: "/capa-assistente.png",
    tags: ["Next.js", "Node.js", "IA / RAG", "n8n", "PostgreSQL"],
  },
  {
    id: "neon",
    route: "/neon",
    titulo: "Neon Finanças",
    descricao:
      "Plataforma de gestão financeira e controle de investimentos com sincronização em tempo real e segurança a nível de linha (RLS).",
    capa: "/capa-neon.png",
    tags: ["Next.js", "Supabase", "TypeScript", "Tailwind"],
  },
  {
    id: "comparador",
    route: "/comparador",
    titulo: "Comparador de Imóveis",
    descricao:
      "Dashboard de inteligência do mercado imobiliário de Joinville, alimentado por web scraping automatizado com n8n.",
    capa: "/capa-comparador-imoveis.png",
    tags: ["React", "Next.js", "Web Scraping", "Supabase"],
  },
  {
    id: "diario",
    route: "/diario",
    titulo: "Diário do Motorista",
    descricao:
      "Sistema de gestão de viagens e despesas para caminhoneiros, com autenticação, cálculos automáticos e dashboard de resumos.",
    capa: "/capa-diario-motorista.png",
    tags: ["React", "Next.js", "Firebase", "PrimeReact"],
  },
  {
    id: "previsao",
    route: "/previsao",
    titulo: "Previsão do Tempo",
    descricao:
      "App de clima em tempo real consumindo APIs externas (OpenWeatherMap e Geonames), com testes automatizados.",
    capa: "/capa-previsao.png",
    tags: ["React", "Material-UI", "APIs", "Jest"],
  },
];

export default projetos;
